<template>
    <div width="100%">
        <v-card-text class="catalog-list">
            <h4 class="mb-2">{{ title }}</h4>
            <v-divider></v-divider>
            <ul>
                <li :class="[{ 'active': inGroupBasket(group) }]" v-for="group in groups" :key="group.id">
                    <v-layout align-center :class="{ mobile: isMobile }">
                        <span class="mr-2 pa-1 pr-1 ml-1 px-1" v-html="renderIcon(group)"
                            @click="toggleGroups(group, 1)"></span>
                        <v-flex @click="toggleGroups(group, 1)"
                            style="white-space: normal !important; word-wrap: break-word;" class=" pb-2 pt-2">
                            <span>{{ group.name }}</span>
                        </v-flex>
                        <v-flex shrink v-if="!isMobile" class="pb-2 pt-2">
                            <button @click="go(group)" class="action white--text text-xs-center pa-1 mr-2 primary">
                                <small>{{ $t("Catalog.go") }}</small>
                            </button>
                            <button @click="toggleGroups(group, 2)" style="width:6em"
                                class="action white--text text-xs-center pa-1 mr-3 primary">
                                <small>{{ $t("Catalog.expand") }}</small>
                            </button>
                        </v-flex>
                        <v-flex shrink v-else class="pb-2 pt-2">
                            <button @click="go(group)" class="pa-1">
                                <v-icon color="primary">search</v-icon>
                            </button>
                            <button @click="toggleGroups(group, 2)" class="pa-1">
                                <v-icon color="primary">arrow_forward</v-icon>
                            </button>
                        </v-flex>
                    </v-layout>
                </li>
            </ul>
        </v-card-text>
    </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    name: "GroupMobile",
    props: {
        groups: {
            type: Array,
        },
        isMobile: {
            type: Boolean,
        },
        title: {
            type: String,
        },
        model: {
            type: String
        }
    },
    computed: {
        ...mapState({
            groupsBasket: state => state.parts.groupsBasket
        }),
        ...mapGetters({
            totalGroupBasketCount: "parts/totalGroupBasketCount",
            basicCatalogRequest: 'parts/basicCatalogRequest'
        })
    },
    methods: {
        ...mapActions({
            INQUIRY: "parts/INQUIRY",
            TOGGLE_SELECTION_GROUP: "parts/TOGGLE_SELECTION_GROUP",
        }),
        renderIcon(group) {
            return this.inGroupBasket(group)
                ? '<i aria-hidden="true" class="v-icon material-icons primary--text">check_box</i>'
                : '<i aria-hidden="true" class="v-icon dark material-icons theme--light">check_box_outline_blank</i>';
        },
        inGroupBasket(group) {
            return (
                this.groupsBasket.findIndex(
                    i => i.id === group.id
                ) !== -1
            )
        },
        toggleGroups(group, typeAction) {
            this.$emit("PreviewFn", group, typeAction)
        },
        selectGroup(group, next = false) {
            this.$emit("Update", group, next )
        },
        go(group) {
          this.$emit("click", { model: this.model, group })
        },
        // async go(group) {
        //     if (!this.inGroupBasket(group)) {
        //         this.TOGGLE_SELECTION_GROUP({ model: this.model, group });
        //     }
        //     await this.INQUIRY({request: this.basicCatalogRequest, page: 1, size: 25, group_by: 'manufacturer' });

        // },
    }
}
</script>